export const GET_DASHBOARD = "GET_DASHBOARD";
export const SET_DASHBOARD = "SET_DASHBOARD";
export const RESET_DASHBOARD = "RESET_DASHBOARD";
